import type { RelatedTransferResponse } from '@on3/api';
import { slugify } from '@on3/ui-lib/utils/slugify';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

import styles from './TransferPortalNavOptions.module.scss';

interface ITransferPortalNavOptions {
  relatedModel?: RelatedTransferResponse;
  className?: string;
}

export const TransferPortalNavOptions = ({
  relatedModel,
  className,
}: ITransferPortalNavOptions) => {
  const router = useRouter();

  const { 'industry-comparison': industryComparison, transferType } =
    router.query;
  const { year, sport, type } = relatedModel || {};

  const isWire = type === 'wire';
  const isTop = type === 'best-available';
  const isIndustry = transferType === 'industry';
  const isOn3Ranking = isTop && !isIndustry;
  const isIndustryRanking = (isIndustry || isWire) && !industryComparison;

  const listType = isIndustryRanking
    ? 'on3-industry'
    : isOn3Ranking
      ? 'on3-ranking'
      : 'industry-comparison';
  const sluggedSport = slugify(sport?.name || 'football');

  const industryLink = isWire
    ? `/transfer-portal/wire/${sluggedSport}/${year}/`
    : `/transfer-portal/industry/${sluggedSport}/${year}/`;

  const industryComparisonLink = isWire
    ? `/transfer-portal/wire/${sluggedSport}/${year}/?industry-comparison=true`
    : `/transfer-portal/industry/${sluggedSport}/${year}/?industry-comparison=true`;

  return (
    <nav className={clsx(styles.block, className)} data-list-type={listType}>
      <ul>
        <li data-type="on3-industry">
          <Link href={industryLink} passHref>
            On3 Industry
          </Link>
        </li>

        {!isWire && (
          <li data-type="on3-ranking">
            <Link
              href={`/transfer-portal/top/${sluggedSport}/${year}/`}
              passHref
            >
              On3 Ranking
            </Link>
          </li>
        )}
        <li data-type="industry-comparison">
          <Link
            data-mobile-text="Ind. Comparison"
            href={industryComparisonLink}
            passHref
          >
            <span>Industry Comparison</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
};
